import api from "@/router/api";

export default {
  async importarLote(formData) {
    const response = await api.post("/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  async consultarStatusLote(loteId) {
    const response = await api.get(`/import/${loteId}/status`);
    return response.data;
  },

  async exportarGex() {
    const response = await api.post("/sigaa/exportar-gex");
    return response.data;
  },
};
